var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 13.559h12.988l-4.47 4.47a.833.833 0 1 0 1.178 1.178l5.893-5.892a.831.831 0 0 0 .104-.127c.014-.021.023-.044.035-.066.014-.025.03-.05.041-.077.012-.028.019-.058.027-.087.007-.023.016-.045.02-.069a.827.827 0 0 0 .017-.163v-.002a.834.834 0 0 0-.017-.161c-.005-.025-.014-.049-.021-.073-.008-.028-.014-.056-.026-.083-.012-.029-.028-.055-.043-.082-.011-.02-.02-.041-.033-.061a.812.812 0 0 0-.105-.128l-5.892-5.892a.834.834 0 0 0-1.178 1.179l4.47 4.47H4.167a.833.833 0 0 0 0 1.666Z",
    fill: "#1D1737"
  })));
};
export default SvgNext;